<div class="filter-panel-content">
  @for (
    selectedFilter of selectedFilters;
    track selectedFilter;
    let i = $index
  ) {
    <div
      class="filters"
      [class.sub-filters-added]="selectedFilter.isSubFilterAdded"
    >
      <odata-filter-item
        [selectedFilter]="selectedFilter"
        [filters]="filters"
        (delete)="deleteFilter(i)"
        (addSubFilter)="addSubFilter(selectedFilter)"
      >
      </odata-filter-item>
      @if (selectedFilter.isSubFilterAdded) {
        <div class="sub-filters">
          <p class="sub-filters-title">Conditions</p>
          @for (
            selectedSubFilter of selectedFilter.selectedSubFilters;
            track selectedSubFilter;
            let i = $index
          ) {
            <div class="filters">
              <odata-filter-item
                [selectedFilter]="selectedSubFilter"
                [filters]="selectedFilter.filter.subFilter.filters"
                (delete)="deleteSubFilter(selectedFilter, i)"
              >
              </odata-filter-item>
            </div>
          }
          <button
            class="add-filter-button"
            mat-button
            color="primary"
            (click)="addSubFilter(selectedFilter)"
          >
            + ADD ANOTHER CONDITION
          </button>
        </div>
      }
    </div>
  }
  <button
    class="add-filter-button"
    mat-button
    color="primary"
    (click)="addFilter()"
  >
    + ADD FILTER
  </button>
</div>
<div class="filter-panel-action-buttons">
  @if (!isValid && isApplied) {
    <p class="error-message">
      Please make sure to select all values, or remove the filter before
      applying.
    </p>
  }
</div>
